import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import HamburgerNav from "./components/HamburgerNav";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import HomePage from "./components/HomePage";
import CalculatorPage from "./components/CalculatorPage";
import GalleryPage from "./components/GalleryPage";
import ContactPage from "./components/ContactPage";
import FAQPage from "./components/FAQPage";
import CalendarPage from "./components/CalendarPage";
import MyProjectsPage from "./components/MyProjectsPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <HamburgerNav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/kalkulators" element={<CalculatorPage />} />
            <Route path="/kalendars" element={<CalendarPage />} />
            <Route path="/projekti" element={<MyProjectsPage />} />
            <Route path="/galerija" element={<GalleryPage />} />
            <Route path="/kontakti" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <FloatingWhatsApp />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
